import { NgModule } from '@angular/core';
import { FittextDirective } from './fittext.directive';

@NgModule({
  declarations: [FittextDirective],
  exports: [FittextDirective],
})
export class FittextModule {}
